import { PathwaysApi } from 'src/api';
import { Pathway } from 'src/api/pathways/types';
import { getCurrentPathStep } from './advancePathProgress';
import { buildPathStepLaunchUrl } from './buildPathStepLaunchUrl';
import { mapPathwayToLearningPathData, PathMappingOptions } from './mapPathwayToLearningPathData';

export type NextPathStepResult =
  | { kind: 'launch'; url: string; updatedPathway?: Pathway; isCheckpoint: boolean }
  | { kind: 'goalComplete' };

/** Bounds the unknown-checkpoint auto-pass loop against a pathological pathway state. */
const MAX_AUTO_PASS_ATTEMPTS = 10;

/**
 * Given a freshly-completed pathway, finds the next step and its launch URL.
 * Checkpoint types with no launch UI are passed automatically and the search
 * continues until a navigable step (or the end of the path) is found.
 */
export const resolveNextPathStepUrl = async (
  languagePairId: number,
  pathway: Pathway,
  mappingOptions: PathMappingOptions = {},
): Promise<NextPathStepResult> => {
  let currentPathway = pathway;
  let updatedPathway: Pathway | undefined;

  for (let attempt = 0; attempt < MAX_AUTO_PASS_ATTEMPTS; attempt += 1) {
    const pathData = mapPathwayToLearningPathData(currentPathway, mappingOptions);
    const step = getCurrentPathStep(pathData);

    if (!step) {
      return { kind: 'goalComplete' };
    }

    const result = await buildPathStepLaunchUrl(languagePairId, step);

    if (result.kind === 'url') {
      return {
        kind: 'launch',
        url: result.url,
        updatedPathway,
        isCheckpoint: step.kind === 'checkpoint',
      };
    }

    currentPathway = await PathwaysApi.passCheckpoint(result.checkpointId);
    updatedPathway = currentPathway;
  }

  return { kind: 'goalComplete' };
};
